import { Transition, Disclosure } from '@headlessui/react'
import Link from 'next/link'
import Image from 'next/image';

export function CheckMark() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="text-orange-600 w-4 h-4 flex-none mr-3">
      <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5" />
    </svg>
  );
}

export default function Faq() {
  return (
    <section className="relative bg-white bg-center overflow-hidden font-['Inter']">
      <div className="bg-transparent">
        <div className="relative pt-16 pb-12">
          <div className="container px-4 md:px-0 mx-auto max-w-3xl lg:max-w-5xl">
            <div className="relative flex flex-wrap justify-center -mx-4">
              <div className="w-full px-4 mb-12 md:mb-0 text-center">
                <h1
                  className="main-top-title mb-16" tabIndex={0}>
                  Frequently Asked Questions<br />
                </h1>
                <div>
                  <div className="w-full px-10">
                    <div className="flex flex-col md:items-left items-center justify-center text-left">
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">What is CKAN?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? ' bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      CKAN (Comprehensive Knowledge Archive Network), is an open-source data management system aimed at assisting organizations with sharing and managing their data effectively. CKAN facilitates simple data publishing and sharing utilizing rich metadata. It provides a powerful platform for cataloging, storing, and accessing datasets with a customizable  front-end, full API (for both data and catalog), visualization tools, and more.<br /><br />
                                      CKAN is usable both &apos;out of the box&apos; and as a powerful framework for creating more tailored systems. CKAN&apos;s combination of an open-source codebase and enterprise support makes it uniquely attractive for organizations looking to build customized, enterprise- or government-grade solutions.<br /><br />
                                      It is globally used by governments, non-profits, enterprises, academic and research institutions to make data discoverable, accessible, and useful to various kinds of users.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">What is CKAN used for?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      CKAN provides a flexible and powerful platform for managing, sharing, and discovering data in a variety of contexts, all the while ensuring data protection and compliance with industry regulations and best practices. CKAN&apos;s support for a variety of data formats and seamlessly integrates with other software systems through APIs make it an excellent solution for organizations looking to improve their data management practices.<br /><br />
                                      CKAN is used for building open data portals, as well as managing internal data catalogs. CKAN can also be used to manage geospatial data. <Link className="underline" href="/faq">See more</Link>
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Why choose CKAN?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow" />
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                        <div className="flex items-start pb-5">
                                          <div className="pt-1"><CheckMark /></div>CKAN is open-source.
                                        </div>
                                        <div className="flex items-start pb-5">
                                          <div className="pt-1"><CheckMark /></div>It makes it easy for users to discover and access data by providing search capabilities, tagging, and filtering options.
                                        </div>
                                        <div className="flex items-start pb-5">
                                          <div className="pt-1"><CheckMark /></div>CKAN is a highly customizable platform, easily tailored to meet the specific needs of an organization.
                                        </div>
                                        <div className="flex items-start pb-5">
                                          <div className="pt-1"><CheckMark /></div>CKAN provides a wide range of features for data management, including data cataloging, data governance, data quality control, data workflows, and data backup and recovery.
                                        </div>
                                        <div className="flex items-start pb-5">
                                          <div className="pt-1"><CheckMark /></div>It can be easily integrated with other tools, such as data visualization or data analysis platforms.
                                        </div>
                                        <div className="flex items-start pb-5">
                                          <div className="pt-1"><CheckMark /></div>CKAN can handle large amounts of data and large numbers of users.
                                        </div>
                                        <div className="flex items-start pb-5">
                                          <div className="pt-1"><CheckMark /></div>Built-in permissions and access controls ensure compliance with data governance and protection regulations.
                                        </div>
                                        <div className="flex items-start pb-5">
                                          <div className="pt-1"><CheckMark /></div>Support for multiple languages makes it a suitable option for organizations that need to share data with users in different
                                          languages.
                                        </div>
                                        <div className="flex items-start pb-5">
                                          <div className="pt-1"><CheckMark /></div>CKAN has a large community of users and developers, which means that there are a lot of support and resources available for organizations that are using CKAN.</div>
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Why is CKAN so popular for open data?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      CKAN gained popularity for open data portals due to its flexibility, scalability, and user experience. CKAN has a user-friendly interface that allows technical and non-technical users to easily manage data on the platform. Additionally, the platform is highly customizable, allowing organizations to tailor it to their specific needs and requirements. CKAN&apos;s extensibility also allows users to add functionality to the platform through custom extensions and plugins, making it more versatile for open data.<br /><br />
                                      CKAN&apos;s popularity can also be attributed to its large user base, which includes many governments, non-profits, and companies. This has led to a wealth of knowledge and resources available for users, including online forums, documentation, and tutorials. Moreover, CKAN is actively developed and maintained by a team of developers and contributors, ensuring regular updates, bug fixes, and security patches, which contributes to the longevity and stability of the platform.<br /><br />
                                      Furthermore, CKAN is designed to be interoperable with other systems and tools, supporting a range of data standards such as DCAT. This makes it easier for organizations to integrate CKAN with their existing systems and to ensure data compliance with international data standards.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Does CKAN support data governance and how?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow" />
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      CKAN supports risk management in several ways:<br /><br />
                                      <b>1</b> -
                                      By inventorying data assets and clarifying ownership you reduce risk of data “rot”. You also reduce loss from inability to find and access essential data.<br /><br />
                                      <b>2</b> -
                                      Clear and rich permissioning reduces your risk from inappropriate sharing of sensitive or confidential data.<br /><br />
                                      <b>3</b> -
                                      CKAN&apos;s data management capabilities accelerate time to insight within the organization and thereby assist the management of risk more generally.<br /><br />
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Can CKAN be used for internal data management?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      Yes, CKAN can be used for internal data management within an organization. CKAN is an open-source platform that provides a secure and centralized location for storing and managing data assets, making it easier to manage data within an organization. CKAN&apos;s data management capabilities, including data cataloging, governance, quality control, workflows, and backup and recovery, make it a powerful tool for managing internal data.<br /><br />
                                      CKAN&apos;s integration capabilities with other tools, such as data visualization or analysis platforms, can support data workflows within an organization, improving data management practices. CKAN can also support compliance with data protection and governance regulations, making it easier for organizations to manage their internal data.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}